var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('the-header'),_c('div',{attrs:{"id":"page"}},[_c('activite',{attrs:{"titre":"Exercice","description":"Ceci est un exe...","note":"12"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }